import { useItem } from "../../../fetch/fetch.item";
import { EMPTY_ITEM } from "../../../const/typeDefault/Item";
import UserTitle from "../../user/core/UserTitle";

const ItemOwner = ({ id }: { id: string }) => {
  const { item, isLoading, isError } = useItem(id, EMPTY_ITEM);
  if (isLoading) return "Loading...";
  if (isError) return isError;
  return <UserTitle userId={item.ownerId} />;
};
export default ItemOwner;
